<template>
    <v-container class="mt-4 pa-0">
        <v-flex>
            <v-card color="primary" class="elevation-1" :style="{ textAlign: 'center' }" v-if="!!repair.length">
                <v-toolbar color="primary" flat>
                    <v-tooltip bottom>
                        <v-toolbar-side-icon slot="activator" @click="reset()" icon>
                            <v-icon>arrow_back</v-icon>
                        </v-toolbar-side-icon>
                        <span>Return to Barcode</span>
                    </v-tooltip>
                    <h2>
                        <span class="hidden-xs-only">Repair Reference -</span>
                        <a target="new"
                            :href="`https://ops.bohmtech.com/web#id=${repair[0].id}&view_type=form&model=mrp.repair`"
                            :style="{ color: '#F04E23', textDecoration: 'none' }" class="ml-2">{{ repair[0].name }}</a>
                        <span class="hidden-xs-only" v-if="repair[0].partner_id"> - {{ repair[0].partner_id[1] }}</span>
                    </h2>
                    <v-icon class="mx-2">fa-phone</v-icon>
                    <v-spacer></v-spacer>
                    <h3 class="hidden-xs-only">{{ repair[0].product_id[1] }}</h3>
                </v-toolbar>

                <div>
                    <v-card color="primary" class="mb-5 elevation-0" :style="{ textAlign: 'center' }" height="400" v-if="step == 'main'">
                        <h2 class="my-5">Polish or submit a final grade</h2>
                        <v-btn color="secondary" @click="step = 'polish'">Polish</v-btn>
                        <v-btn color="primary" @click="step = 'rev_share'">Submit Grade</v-btn>
                    </v-card>
                    <v-card color="primary" class="mb-5 elevation-0" :style="{ textAlign: 'center' }" height="400" v-if="step == 'rev_share'">
                        <h2 class="my-2">Send to Rev Share</h2>
                        <v-select :items="['Certified Refurbished', 'Refurbished', 'Pre-Owned', 'Used', 'W. Used']"
                            v-model="condition" color="secondary" label="Select Condition" box
                            :style="{ width: '50%', margin: 'auto' }"></v-select>
                        <v-select :items="allPrinters" v-model="selectedPrinter" color="secondary"
                            label="Select Printer" box :style="{ width: '50%', margin: 'auto' }"></v-select>
                        <div class="mb-4">
                            <v-btn color="secondary" @click="printRevShareLabel()">Print Label</v-btn>
                            <v-btn color="primary" @click="step = 'main'">Cancel</v-btn>
                            <v-btn color="primary" @click="reset()">Go Home</v-btn>
                        </div>
                        
                    </v-card>

                    <v-card color="primary" class="mb-5 elevation-0" :style="{ textAlign: 'center' }" height="400" v-if="step == 'polish'">
                        <h2 class="mt-5 mb-2">Send to polishing</h2>
                        <v-select :items="allPrinters" v-model="selectedPrinter" color="secondary"
                            label="Select Printer" box :style="{ width: '50%', margin: 'auto' }"></v-select>
                        <div>
                            <v-btn color="secondary" @click="polishRevShare(1)">Polish Front</v-btn>
                            <v-btn color="secondary" @click="polishRevShare(2)">Polish Back</v-btn>
                            <v-btn color="secondary" @click="polishRevShare(3)">Polish Both</v-btn>
                            <v-btn color="primary" @click="step = 'main'">Cancel</v-btn>
                            <v-btn color="primary" @click="reset()">Go Home</v-btn>
                        </div>
                    </v-card> 
                </div>
            </v-card>
        </v-flex>
    </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import LoginCheck from "@/mixins/LoginCheck";
import Common from "@/mixins/Common";

export default {
    name: "phone",
    mixins: [LoginCheck, Common],

    data() {
        return {
            repairState: false,
            grades: [],
            step: "main",
            gradeDataPagination: {
                rowsPerPage: 10,
                sortBy: "evalDate",
                descending: true,
                page: 1
            },
            originalState: false,
            condition: false,
        };
    },
    computed: {
        ...mapGetters({
            repair: "repair/getRepair",
            repairOperations: "repair/getRepairOperations",
            possibleGrades: "repair/getGrades",
            storedPrinter: "repair/getSelectedPrinter",
            allPrinters: "repair/getAllPrinters",
            user: "app/getUser",
            foundProduct: "product/getProduct",

        }),
        selectedPrinter: {
            get() {
                return this.storedPrinter;
            },
            set(val) {
                return this.$store.commit("repair/setSelectedPrinter", val);
            },
        },

        housingGrade() {
            return this.grades[1] || {
                text: 'A',
                color: 'green',
                value: 100
            };
        },

        lcdGrade() {
            return this.grades[0] || {
                text: 'A',
                color: 'green',
                value: 100
            };
        },

        finalGrade() {
            return this.lcdGrade.value >= this.housingGrade.value
                ? this.housingGrade
                : this.lcdGrade;
        },
    },
    async beforeMount() {
        await this.searchServices({ serial: this.$route.params.id });
        await this.getAllPrinters();
        await this.getOperation({ id: this.repair[0].id });
        if (this.repair.length) {
            this.repairState = this.repair[0].state;
            this.originalState = this.repair[0].state;
        } else {
            this.reset();
        }
    },

    methods: {
        ...mapActions({
            searchServices: "repair/searchServices",
            sendToPolishing: "repair/sendToPolishing",
            submitGradeToOdoo: "repair/submitGrade",
            getAllPrinters: "repair/getAllPrinters",
            printCustomLabel: "repair/printCustomLabel",
            getOperation: "repair/getRepairOperations",
            addOperation: "repair/addOperation",
        }),

        async polishRevShare(side) {
            if (!this.selectedPrinter) {
                this.$store.dispatch("app/setSnackbar", {
                    text: "Please Select a Printer!",
                    color: "red",
                });
            }
            let text = "";
            switch (side) {
                case 1:
                    text = "Polish Front";
                    break;
                case 2:
                    text = "Polish Back";
                    break;
                case 3:
                    text = "Polish Both";
                    break;
                default:
                    break;
            }

            const success = await this.printCustomLabel({
                text: text,
                printer: this.selectedPrinter,
            });
            if (success) {
                await this.submitGradeToOdoo({
                grade: {
                    grade_name: "Housing Grade",
                    grade_result: this.housingGrade.text,
                    grade_value: this.housingGrade.value,
                    repair_id: this.repair[0].id,
                    is_final: false,
                }
            });
            this.$store.dispatch("app/setSnackbar", {
                text: "Sent to Polishing!",
                color: "green",
            });
            } else {
                this.$store.dispatch("app/setSnackbar", {
                    text: "Failed to send to Polishing!",
                    color: "red",
                });
            }

            this.reset();
        },

        async printRevShareLabel() {
            if (!this.selectedPrinter) {
                this.$store.dispatch("app/setSnackbar", {
                    text: "Please Select a Printer!",
                    color: "red",
                });
            }
            else if (!this.condition) {
                this.$store.dispatch("app/setSnackbar", {
                    text: "Please Select a Condition!",
                    color: "red",
                });
            } else {

                const success = await this.printCustomLabel({
                    text: this.condition,
                    printer: this.selectedPrinter,
                });
                if (success) {
                    await this.addOperation({
                        repairID: this.repair[0].id,
                        step: "Grading"
                    });
                    this.$store.dispatch("app/setSnackbar", {
                        text: "Label(s) printed to " + this.selectedPrinter,
                        color: "green",
                    });
                } else {
                    this.$store.dispatch("app/setSnackbar", {
                        text: res.message,
                        color: "red",
                    });
                }
            }
        },

        reset() {
            this.$store.commit("repair/setRepair", []);
            this.step = "main";
            this.$router.push("/phone-grading");
        },
    }
};
</script>

<style>
.grade-circle {
    width: 400px;
    height: 400px;
    border-radius: 50%;
    font-size: 90px;
    line-height: 400px;
    text-align: center;
    border: 1px solid;
}
</style>